import * as yup from 'yup';
import { PAYMENT_METHODS, PaymentMethod } from './helpers/paymentMethods';

export interface IPaymentLinkFormValues {
  email: string;
  document: string;

  paymentMethodSelected: PaymentMethod;

  cardHolderName: string;
  cardNumber: string;
  cardExpiration: string;
  cardCvv: string;

  zipCode: string;
  state: string;
  city: string;
  address: string;
  addressNumber: string;
  addressComplement: string;
}

export const INITIAL_PAYMENT_LINK_VALUES: IPaymentLinkFormValues = {
  email: '',
  document: '',
  paymentMethodSelected: 'credit_card',
  cardHolderName: '',
  cardNumber: '',
  cardExpiration: '',
  cardCvv: '',
  zipCode: '',
  state: '',
  city: '',
  address: '',
  addressNumber: '',
  addressComplement: '',
};

const requiredForCreditCard = (message: string) =>
  yup.string().when('paymentMethodSelected', {
    is: 'credit_card',
    then: schema => schema.required(message),
    otherwise: schema => schema.notRequired(),
  });

export const paymentLinkSchema = yup.object({
  paymentMethodSelected: yup
    .string()
    .oneOf(Object.keys(PAYMENT_METHODS))
    .required('Selecione um método de pagamento.'),
  email: yup
    .string()
    .email('Informe um e-mail válido.'),
  document: yup
    .string(),

  cardHolderName: requiredForCreditCard('O nome do titular do cartão é obrigatório.',),
  cardNumber: requiredForCreditCard('O número do cartão é obrigatório.',),
  cardExpiration: requiredForCreditCard('A validade do cartão é obrigatória.',),
  cardCvv: requiredForCreditCard('O CVV é obrigatório.',),

  zipCode: yup.string().required('O CEP é obrigatório.'),
  state: yup.string().required('O estado é obrigatório.'),
  city: yup.string().required('A cidade é obrigatória.'),
  address: yup.string().required('O endereço é obrigatório.'),
  addressNumber: yup.string().required('O número é obrigatório.'),
  addressComplement: yup.string(),
});

export type PaymentLinkFormValues =
  yup.InferType<typeof paymentLinkSchema>;
